import { render, staticRenderFns } from "./DatosAbono.vue?vue&type=template&id=21a8a5c2&scoped=true"
import script from "./DatosAbono.vue?vue&type=script&lang=js"
export * from "./DatosAbono.vue?vue&type=script&lang=js"
import style0 from "./DatosAbono.vue?vue&type=style&index=0&id=21a8a5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8a5c2",
  null
  
)

export default component.exports